import { useState, useEffect, useContext, createContext } from "react";
import { getRouteControlByRole } from "utils/RouteFilter";

const RoleControlContext = createContext({
    role: null,
    routeControl: null,
});

export const useRoleControl = () => useContext(RoleControlContext);

export default function RoleControlProvider({
    children,
    initialRole
}) {
    const [role, setRole] = useState(initialRole);

    const routeControl = getRouteControlByRole(role);

    useEffect(() => {
        setRole(initialRole)
    }, [initialRole])

    return (
        <RoleControlContext.Provider
            value={{
                role,
                routeControl,
            }}
        >
            {children}
        </RoleControlContext.Provider>
    )
}
